// src/components/ledger/components/LedgerSummaryStrip.tsx
import React from "react";
import { Switch, FormControlLabel } from "@mui/material";
import { useUserTheme } from "src/shared/utils/useUserTheme";

interface Props {
  totalRecords: number;
  totalOutstanding: string;
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showZeroOutstanding: boolean;
  onToggleZeroOutstanding: () => void;
}

const LedgerSummaryStrip: React.FC<Props> = ({ totalRecords, totalOutstanding, searchTerm, onSearchChange, showZeroOutstanding, onToggleZeroOutstanding }) => {
  const { fontClass, borderHighlight } = useUserTheme();

  return (
    <div className="w-full xl:w-[100%] mx-auto mt-5 flex flex-col lg:flex-row flex-wrap items-start lg:items-center gap-4">
      <div className="flex flex-col items-center min-w-[130px] lg:min-w-[150px] xl:min-w-[350px] px-3 py-2 border border-gray-200 shadow-inner rounded-lg bg-white p-2">
        <span className="text-base lg:text-lg">Total Customers</span>
        <h1 className="text-red-600 font-semibold text-xl lg:text-2xl mt-1">{totalRecords}</h1>
      </div>

      <div className="flex flex-col items-center min-w-[150px] lg:min-w-[180px] xl:min-w-[350px] px-3 py-2 border border-gray-200 shadow-inner rounded-lg bg-white p-2">
        <span className="text-base lg:text-lg">Total Outstanding</span>
        <h1 className="text-red-600 font-semibold text-xl lg:text-2xl mt-1">{totalOutstanding}</h1>
      </div>

      <div className="flex items-center h-[50px] w-full sm:w-auto gap-3 flex-1">
        <input
          name="Ledger search"
          value={searchTerm}
          onChange={onSearchChange}
          placeholder="Ledger search by Name or Phone number"
          className={`w-full sm:max-w-[150px] lg:max-w-[250px] xl:max-w-[290px] px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${borderHighlight} ${fontClass} text-sm text-black`}
        />

        <FormControlLabel
          control={
            <Switch
              // Logic: Invert the value so that 'false' results in an 'On' switch
              checked={!showZeroOutstanding}
              onChange={onToggleZeroOutstanding}
              color="primary"
            />
          }
          label={
            // When false (default), it means we are currently Excluding.
            // When true (toggled), it means we are currently Including.
            showZeroOutstanding ? "Include Zero Balance" : "Exclude Zero Balance"
          }
          className="select-none"
        />
      </div>
    </div>
  );
};

export default LedgerSummaryStrip;
